// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { IRoleResponseDto } from './IRoleResponseDto';
import {
    IRoleResponseDtoFromJSON,
    IRoleResponseDtoFromJSONTyped,
    IRoleResponseDtoToJSON,
    IRoleResponseDtoToJSONTyped,
} from './IRoleResponseDto';

/**
 * 
 * @export
 * @interface IPageRoleResponseDto
 */
export interface IPageRoleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageRoleResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageRoleResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageRoleResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IRoleResponseDto>}
     * @memberof IPageRoleResponseDto
     */
    content?: Array<IRoleResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageRoleResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageRoleResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageRoleResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageRoleResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageRoleResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageRoleResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageRoleResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageRoleResponseDto interface.
 */
export function instanceOfIPageRoleResponseDto(value: object): value is IPageRoleResponseDto {
    return true;
}

export function IPageRoleResponseDtoFromJSON(json: any): IPageRoleResponseDto {
    return IPageRoleResponseDtoFromJSONTyped(json, false);
}

export function IPageRoleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageRoleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IRoleResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageRoleResponseDtoToJSON(json: any): IPageRoleResponseDto {
    return IPageRoleResponseDtoToJSONTyped(json, false);
}

export function IPageRoleResponseDtoToJSONTyped(value?: IPageRoleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IRoleResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

